export interface Theme {
  id: string;
  name: string;
  image: string;
  colors: {
    primary: string;
    secondary: string;
    accent: string;
    background: string;
    surface: string;
    text: string;
    textSecondary: string;
    border: string;
  };
}

export const themes: Theme[] = [
  {
    id: 'default',
    name: 'Solo Leveling Blue',
    image: '/themes/theme-blue.jpg',
    colors: {
      primary: '#3B82F6',
      secondary: '#8B5CF6',
      accent: '#60A5FA',
      background: 'rgba(15, 23, 42, 0.85)',
      surface: 'rgba(30, 41, 59, 0.9)',
      text: '#FFFFFF',
      textSecondary: '#94A3B8',
      border: '#3B82F6',
    },
  },
  {
    id: 'shadow',
    name: 'Shadow Monarch',
    image: '/themes/theme-shadow.jpg',
    colors: {
      primary: '#8B5CF6',
      secondary: '#6366F1',
      accent: '#A78BFA',
      background: 'rgba(15, 10, 25, 0.85)',
      surface: 'rgba(30, 20, 45, 0.9)',
      text: '#FFFFFF',
      textSecondary: '#A78BFA',
      border: '#8B5CF6',
    },
  },
  {
    id: 'red',
    name: 'Blood Red',
    image: '/themes/theme-red.jpg',
    colors: {
      primary: '#DC2626',
      secondary: '#991B1B',
      accent: '#F87171',
      background: 'rgba(25, 10, 10, 0.85)',
      surface: 'rgba(45, 20, 20, 0.9)',
      text: '#FFFFFF',
      textSecondary: '#FCA5A5',
      border: '#DC2626',
    },
  },
  {
    id: 'ice',
    name: 'Ice Monarch',
    image: '/themes/theme-ice.jpg',
    colors: {
      primary: '#06B6D4',
      secondary: '#0891B2',
      accent: '#67E8F9',
      background: 'rgba(10, 20, 30, 0.85)',
      surface: 'rgba(20, 35, 50, 0.9)',
      text: '#FFFFFF',
      textSecondary: '#A5F3FC',
      border: '#06B6D4',
    },
  },
  {
    id: 'gold',
    name: 'S-Rank Hunter',
    image: '/themes/theme-gold.jpg',
    colors: {
      primary: '#F59E0B',
      secondary: '#D97706',
      accent: '#FCD34D',
      background: 'rgba(30, 20, 10, 0.85)',
      surface: 'rgba(50, 35, 20, 0.9)',
      text: '#FFFFFF',
      textSecondary: '#FDE68A',
      border: '#F59E0B',
    },
  },
  {
    id: 'jeju',
    name: 'Jeju Island',
    image: '/themes/theme-jeju.jpg',
    colors: {
      primary: '#10B981',
      secondary: '#059669',
      accent: '#34D399',
      background: 'rgba(10, 25, 15, 0.85)',
      surface: 'rgba(20, 45, 30, 0.9)',
      text: '#FFFFFF',
      textSecondary: '#A7F3D0',
      border: '#10B981',
    },
  },
];

export const themeService = {
  getCurrentTheme: (): Theme => {
    const savedThemeId = localStorage.getItem('selectedTheme') || 'default';
    return themes.find(t => t.id === savedThemeId) || themes[0];
  },

  setTheme: (themeId: string): void => {
    const theme = themes.find(t => t.id === themeId);
    if (!theme) return;

    localStorage.setItem('selectedTheme', themeId);
    
    // Apply CSS variables ONLY (colors, not backgrounds)
    const root = document.documentElement;
    root.style.setProperty('--color-primary', theme.colors.primary);
    root.style.setProperty('--color-secondary', theme.colors.secondary);
    root.style.setProperty('--color-accent', theme.colors.accent);
    root.style.setProperty('--color-background', theme.colors.background);
    root.style.setProperty('--color-surface', theme.colors.surface);
    root.style.setProperty('--color-text', theme.colors.text);
    root.style.setProperty('--color-text-secondary', theme.colors.textSecondary);
    root.style.setProperty('--color-border', theme.colors.border);
    
    // DEPRECATED: Background images are now handled by BackgroundRenderer component
    // The old body.style.backgroundImage caused persistent backgrounds that wouldn't clear
    // Backgrounds are now fully controlled through BackgroundCustomizer -> BackgroundRenderer
  },

  initializeTheme: (): void => {
    const theme = themeService.getCurrentTheme();
    themeService.setTheme(theme.id);
    
    // Re-apply theme on window resize (handles device rotation)
    let resizeTimeout: NodeJS.Timeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const currentTheme = themeService.getCurrentTheme();
        themeService.setTheme(currentTheme.id);
      }, 250); // Debounce to avoid excessive calls
    });
  },

  getAllThemes: (): Theme[] => {
    return themes;
  },
};



